import React from 'react';
import sheen from '../assets/images/sheen.gif';

const ALBUM_COVERS = {
  topRow: [
    'https://i.scdn.co/image/ab67616d0000b273dc30583ba717007b00cceb25', // Abbey Road
    'https://i.scdn.co/image/ab67616d0000b2733f29c5269be5a4e9c4611d7a', // Bitches Brew
    'https://i.scdn.co/image/8e79e679cb589f6790373bc878a820ba65ffe835', // Key Of Life
    'https://i.scdn.co/image/2b78959aeaf66aa1889a2afb819f18ba9e585c50', // Africa Brasil
    'https://i.scdn.co/image/ab67616d0000b2735aa1262c4123fedc2e4b8c44', // Wish You Were Here
    'https://i.scdn.co/image/ab67616d0000b273fbc71c99f9c1296c56dd51b6', // Nevermind
    'https://i.scdn.co/image/ab2eae28bb2a55667ee727711aeccc7f37498414', // Paranoid
    'https://i.scdn.co/image/ab67616d0000b273fa8d314f6f91e81889335dfc', // De La Soul
    'https://i.scdn.co/image/df53a186c41bf130c6f56627334c9b751d27ff84', // Are You Experienced
    'https://i.scdn.co/image/ab67616d0000b2737ab89c25093ea3787b1995b4', // Kind of Blue
  ],
  bottomRow: [
    'https://i.scdn.co/image/5ab6d44ba4ae35dd47891bc7989c0fe85d9662be', // Sincere
    'https://i.scdn.co/image/ab67616d0000b273f32a4535c09f7cae822bd695', // Volta
    'https://i.scdn.co/image/2e270fba66caa86720fdc1ab59fb9a7bb4717e5c', // Ziggy
    'https://i.scdn.co/image/a2d2e344c72496aa6da5fea6a10af9f561b76cfd', // Young Gods
    'https://i.scdn.co/image/d64cdeaad56a5bba451950824595e5b007124cd9', // Purple Rain
    'https://i.scdn.co/image/4cc8ab2ec5734759c5de2eed34ea975339fcb27d', // Spy VS Spy
    'https://i.scdn.co/image/408a440c4e50d9cb381248b84cfb84824670672b', // Ok Computer
    'https://i.scdn.co/image/ab67616d0000b2734718e2b124f79258be7bc452', // Star Boy
    'https://i.scdn.co/image/ab67616d0000b273b36949bee43217351961ffbc', // Gaye
    'https://i.scdn.co/image/31ee3e4265ba3c5098a8928c05d001a3b3033710', // Rumors
    'https://i.scdn.co/image/a522c89d9d23539071d1f4b334dc2d50cabc3693', // London Calling
  ]
};

const Album = ({ imageUrl }) => {
  if (!imageUrl) return null;
  
  return (
    <div className="
      flex lg:-translate-y-2 -translate-y-1
      xl:w-[7rem] lg:w-[6rem] md:w-[4rem] sm:w-[3rem] w-[2rem]
    ">
      <img 
        className="flex w-full h-full object-contain aspect-square" 
        src={imageUrl}
        alt=""
      />
    </div>
  );
};

const About = () => {
  return (
    <div className="flex flex-col gap-32 pt-24 pb-32">

      <div className="relative flex flex-col items-center justify-center w-full
        text-center pangram-sans-bold text-amber-50 uppercase
        xl:text-[10rem] lg:text-[8.5rem] md:text-[6.5rem] text-[5rem]
        xl:leading-[9rem] lg:leading-[7.5rem] md:leading-[5.75rem] leading-[4.5rem]">

        <div className="flex items-center justify-center w-full text-center drop-shadow-[black_-5px_5px] z-10">
          1001
        </div>
        <div className="flex items-center justify-center w-full text-center drop-shadow-[black_-5px_5px] z-10">
          AG
          <span className="
            material-symbols-outlined drop-shadow-[black_-5px_5px] z-10
            lg:-mx-4 md:-mx-3 sm:-mx-2 -mx-1
            xl:text-[10rem] lg:text-[8rem] md:text-[7rem] text-[5rem]
          ">electric_bolt</span>
          DC
        </div>
        <div className="
          absolute aspect-square top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 opacity-60
          xl:w-[32rem] lg:w-[26rem] md:w-[22rem] sm:w-[20rem] w-[18rem]
        ">
          <img
            src={sheen}
            className="w-full h-full"
            alt=""
          />
        </div>
      </div>

      <div className="flex md:flex-row flex-col gap-x-8 gap-y-16 w-full mx-auto md:px-8 px-4">
        
        <div className="flex lg:w-2/4 w-full items-start flex-col gap-4 text-amber-50 text-lg text-justify">
          <div className="w-full text-center pangram-sans-narrow-extrabold text-amber-50 uppercase
          xl:text-[9rem] lg:text-[7.5rem] md:text-[5.5rem] sm:text-[4rem] text-[3rem]
          xl:leading-[8rem] lg:leading-[6.5rem] md:leading-[4.75rem] sm:leading-[3.5rem] leading-[2.7rem]">
            What
          </div>
          <p className="w-full">1001 AG/DC is a remix of the <a className="underline cursor-pointer" href="https://1001albumsgenerator.com/" target="_blank" rel="noreferrer" data-adblock-ignore>1001 Albums Generator</a> project.</p>
          <p className="w-full">Since I'm just using the API, it doesn't have all the features of the main app (e.g. can't rate and review albums) it is an attempt to make the experience a little more visual and robust.</p>
          <p className="w-full">Tech stack: <a className="underline cursor-pointer" href="https://nextjs.org/" target="_blank" rel="noreferrer" data-adblock-ignore>Next.js</a>, <a className="underline cursor-pointer" href="https://react.dev/" target="_blank" rel="noreferrer" data-adblock-ignore>React</a>, <a className="underline cursor-pointer" href="https://tailwindcss.com/" target="_blank" rel="noreferrer" data-adblock-ignore>Tailwind CSS</a>, and <a className="underline cursor-pointer" href="https://vercel.com/" target="_blank" rel="noreferrer" data-adblock-ignore>Vercel</a>.</p>
          <p className="w-full">Tools & Resources: <a className="underline cursor-pointer" href="https://code.visualstudio.com/" target="_blank" rel="noreferrer" data-adblock-ignore>Visual Studio Code</a>, <a className="underline cursor-pointer" href="https://desktop.github.com/download/" target="_blank" rel="noreferrer" data-adblock-ignore>GitHub for Desktop</a>, <a className="underline cursor-pointer" href="https://claude.ai/" target="_blank" rel="noreferrer" data-adblock-ignore>Claude ai</a>, and <a className="underline cursor-pointer" href="https://wikipedia.com/" target="_blank" rel="noreferrer" data-adblock-ignore>Wikipedia</a>'s API. Type set in <a className="underline cursor-pointer" href="https://pangrampangram.com/products/pangram-sans" target="_blank" rel="noreferrer" data-adblock-ignore>Pangram Sans.</a></p>
        </div>

        <div className="flex lg:w-2/4 w-full items-start flex-col gap-4 text-amber-50 text-lg text-justify">
          <div className="w-full text-center pangram-sans-narrow-extrabold text-amber-50 uppercase
          xl:text-[9rem] lg:text-[7.5rem] md:text-[5.5rem] sm:text-[4rem] text-[3rem]
          xl:leading-[8rem] lg:leading-[6.5rem] md:leading-[4.75rem] sm:leading-[3.5rem] leading-[2.7rem]">
            Who
          </div>
          <p className="w-full">I'm David Carroll 👋 I discovered the <a className="underline cursor-pointer" href="https://1001albumsgenerator.com/" target="_blank" rel="noreferrer" data-adblock-ignore>1001 Albums Generator</a> project on February 6, 2024. I'm on album 209 as I write this. 792 to go!</p>
          <p className="w-full">As a music lover and wannabe coder, this remix was a great way to feel closer to the albums while expand my dev horizons. Bingo bongo.</p>
          <p className="w-full">Projects like this take me back to days when so much of the internet felt like a wonderful mess of little one-off labors-of-love. For the sake of fun and collaboration.</p>
        </div>

      </div>

      <div className="flex flex-col w-full items-center justify-center text-amber-50">

        <div className="
          flex flex-col w-full items-center justify-center uppercase pangram-sans-narrow-extrabold
          xl:text-[9rem] lg:text-[7.5rem] md:text-[5.5rem] sm:text-[4rem] text-[3rem]
          xl:leading-[8rem] lg:leading-[6.5rem] md:leading-[4.75rem] sm:leading-[3.5rem] leading-[2.7rem]
        ">
          <div className="flex text-center">Hear the 1001</div>
          <div className="flex text-center">Most Important</div>
          <div className="flex w-full flex-row sm:gap-4 gap-2 justify-start text-center overflow-clip">
            <div className="md:ml-8 ml-4 whitespace-nowrap">Albums</div>
            <div className="relative flex flex-row w-full">
              <div className="flex flex-row lg:gap-4 gap-2 absolute left-0 top-1/2 sm:-translate-y-[calc(50%-8px)] -translate-y-[calc(50%-4px)]">
                {ALBUM_COVERS.topRow.map((url, index) => (
                  <Album key={`bottom-${index}`} imageUrl={url} />
                ))}
              </div>
            </div>
          </div>
          <div className="flex w-full flex-row sm:gap-4 gap-2 justify-end text-center overflow-clip">
            <div className="flex flex-row relative w-full">
              <div className="flex flex-row lg:gap-4 gap-2 absolute right-0 top-1/2 sm:-translate-y-[calc(50%-8px)] -translate-y-[calc(50%-4px)]">
                {ALBUM_COVERS.bottomRow.map((url, index) => (
                  <Album key={`bottom-${index}`} imageUrl={url} />
                ))}
              </div>
            </div>
            <div className="md:mr-8 mr-4 whitespace-nowrap">One A Day</div>
          </div>
        </div>

        <div className="flex flex-col w-full items-center justify-center">
          <a href="https://1001albumsgenerator.com/" target="_blank" rel="noreferrer" data-adblock-ignore
            className="flex items-center mt-8 px-8 py-4 md:text-4xl text-xl uppercase pangram-sans-bold tracking-wide outline-none border-4 border-solid border-amber-50 text-amber-50 rounded-full hover:scale-105 transition duration-100 ease-in-out cursor-pointer">
            Start Your Journey
          </a>
        </div>

      </div>
    </div>
  );
};

export default About;